module.exports = __webpack_public_path__ + "img/bank.ec3481d1.png";